import userflow from 'userflow.js'
import * as Sentry from '@sentry/core'

export function triggerFlow(flowId: string) {
  if (!process.env.USER_FLOW_TOKEN || !flowId) {
    return
  }
  Promise.resolve(userflow.start(flowId)).catch((error) => {
    console.error('Error triggering userflow survey', error)
    Sentry.captureException(error)
  })
}
